/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Einzelne Version verwalten
 * 
 * In diesem Dialog kann eine einzelne Version in einem Modal-Dialog angezeigt,
 * geändert oder gelöscht werden. Live- oder Draft-Versionen können nicht geändert 
 * oder gelöscht werden.
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import { ModalTitle } from "../../partials/ModalTitle";
import * as appActions from "../../../store/actions/appActions";
import * as versionActions from '../../../store/actions/versionActions';


const styles = (theme) => ({
    form: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(1),
        minWidth: 400,
    },
    message: {
        color: 'rgb(238,60,54)',
        marginLeft: '2%'
    }
});

class VersionModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'VersionModal'

        this.state = {
            newVersion: {
                id: 0,
                version: ''
            }
        }
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================

    componentDidUpdate(prevProps) {
        const { modalDialog } = this.props.app;

        if (modalDialog.dialog === 'version' && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {
            this.setState({ newVersion: this.props.version.currentVersion })
        }
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog } = this.props.app;
        const { newVersion } = this.state;
        const { version, classes } = this.props;

        const onSave = () => {
            if (modalDialog.type === 'create') {
                this.props.createVersion(newVersion)
            }
            if (modalDialog.type === 'update') {
                this.props.updateVersion(newVersion.id, newVersion)
            }
            if (modalDialog.type === 'delete') {
                this.props.deleteVersion(newVersion.id)
            }
        };

        const onCancel = () => {
            this.props.setModalDialog(null, null)
        };

        const onChange = (e) => {
            this.setState({ newVersion: { ...newVersion, [e.target.id]: e.target.value } });
        }

        const onSubmit = (e) => {
            e.preventDefault();
        }

        const getError = (id) => {

            const noError = { error: false, message: '' }

            if (!version['error']) return noError;
            if (!version.error['data']) return noError;
            if (!version.error.data['errors']) return noError;
            if (!version.error.data.errors.length === 0) return noError;

            const errorFound = version.error.data.errors.filter((d) => d.param === id)
            if (errorFound.length > 0) {
                return { error: true, message: errorFound[0].msg };
            }
            return noError;
        }

        // ==========================================================================
        //
        // SUB RENDER
        //
        // ==========================================================================

        const renderTextField = (id, label, type, autoFocus, disabled) => {

            return (
                <TextField
                    autoFocus={autoFocus}
                    id={id}
                    label={label}
                    type={type}
                    fullWidth
                    disabled={disabled}
                    value={newVersion[id]}
                    onChange={onChange}
                    InputLabelProps={{ shrink: true }}
                    margin="normal"
                    error={getError(id).error}
                    helperText={getError(id).message}
                />
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== 'version') return null;

        let dialogTitle = '';
        if (modalDialog.type === 'create') dialogTitle = 'Version erstellen';
        if (modalDialog.type === 'update') dialogTitle = 'Version ändern';
        if (modalDialog.type === 'delete') dialogTitle = 'Version löschen';


        const disabled = modalDialog.type === 'delete';

        return (
            <div>
                <Dialog open={true} onClose={onCancel} maxWidth={'md'} aria-labelledby="form-dialog-title" >
                    <ModalTitle onClose={onCancel}>{dialogTitle}</ModalTitle>
                    <DialogContent>
                        <form className={classes.form} noValidate onSubmit={onSubmit}>
                            <FormControl className={classes.formControl}>

                                {renderTextField('id', 'Versions-Nr', 'text', false, disabled)}
                                {renderTextField('version', 'Version', 'text', true, disabled)}

                                <Typography className={classes.message} variant="h6" noWrap>
                                    {version.error !== null ? version.error.data.message : <br />}
                                </Typography>
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} variant="outlined" color="default">Abbruch</Button>
                        <Button onClick={onSave} variant="contained" color="primary">OK</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        version: state.version,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, versionActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VersionModal));